import { API_RESPONSE } from '@/common/constants';
import type { CalcPayload, FeedbackData, UploadFileType } from '@/common/types';

export function useCalcSubmit() {
	const loading = useLoadingIndicator();

	async function postUploadFiles(orderId: number, files: UploadFileType[]) {
		try {
			const runtimeConfig = useRuntimeConfig();
			const formData = new FormData();

			files.forEach((f) => {
				formData.append('files', f.file);
			});

			await $fetch(`/api/local/order/${orderId}/addFiles`, {
				baseURL: runtimeConfig.public.API_URL,
				method: 'POST',
				body: formData
			});
		} catch (error) {
			console.log(error);
		}
	}

	async function postSubmitCalculator(
		feedbackData: FeedbackData,
		payload: Required<CalcPayload>,
		files: UploadFileType[]
	) {
		const ymTriggers = useYmTriggers();

		try {
			loading.start();
			const runtimeConfig = useRuntimeConfig();
			const utm = useNuxtApp().$getUtmData();

			const siteName =
				runtimeConfig.public.NUXT_PUBLIC_SITE_URL?.trim() ||
				'train73.pro';

			const body = {
				...utm,
				...feedbackData,
				number: feedbackData.phone,
				payload,
				siteName
			};

			const res = await $fetch<{ id: number }>(
				'/api/local/order/web-delivery',
				{
					baseURL: runtimeConfig.public.API_URL,
					method: 'POST',
					body
				}
			);

			if (files.length) {
				await postUploadFiles(res.id, files);
			}

			ymTriggers.hitOrderNow();

			return {
				success: true,
				message: API_RESPONSE.success
			};
		} catch (error) {
			console.log(error);
			return {
				success: false,
				message: API_RESPONSE.error
			};
		} finally {
			loading.finish();
		}
	}

	return { postSubmitCalculator, isLoading: loading.isLoading.value };
}
